import Common from '../common/Common';
import { strBoolToBool } from '../common/util';
import { LNB_LINK_TYPE } from '../common/const';

export const getLinkTmpl = (data) => {
    if(!data || typeof data !== 'object') {
        return '';
    }

    const com = Common.instance;

    const getIconType = (iconType) => {
        return Array.isArray(iconType) ? iconType : (iconType && typeof iconType === 'string' && typeof strBoolToBool(iconType) !== 'boolean') ? [iconType] : [];
    };

    const {
        className = '',
        iconType = '',
        title = '',
        url = '',
        popName = '',
        popOption = 'menubar=0,toolbar=0',
        popInPCOnly = '',
        id,
        onClick
    } = data || {};

    let typeArr = getIconType(iconType);
    let lastType = typeArr?.length > 0 ? typeArr[typeArr.length - 1] : null; // iconType: []일 때, 마지막 type으로 마크업 생성
    let newUrl = url;
    let props =  '';
    let icon = '';

    if (strBoolToBool(popInPCOnly)) {
        if (typeArr?.includes(LNB_LINK_TYPE.POPUP) && com?.isMobile) {
            typeArr = typeArr.filter(v => v !== LNB_LINK_TYPE.POPUP);
            lastType = typeArr?.length > 0 ? typeArr[typeArr.length - 1] : null;
        }
    }

    switch (lastType) {
        case LNB_LINK_TYPE.EXTERNAL:
            props = ` data-type="${LNB_LINK_TYPE.EXTERNAL}" target="_blank"`;
            break;
        case LNB_LINK_TYPE.POPUP:
            newUrl = 'javascript:void(0)';
            props = ` data-type="${LNB_LINK_TYPE.POPUP}" onclick="window.open('${url}', '${com?.setLinkTarget(popName)}', '${popOption}').focus();return false;"`;
            break;
        case LNB_LINK_TYPE.NEW:
            props = ` data-type="${LNB_LINK_TYPE.NEW}"`;
            break;
        default:
            props = ` target="_self"`;
            break;
    }
    
    if(Array.isArray(typeArr) && typeArr?.length > 0) {
        icon = typeArr?.map(type => type ? `<em class="icon-${type === LNB_LINK_TYPE.POPUP ? LNB_LINK_TYPE.EXTERNAL : type}">${type === LNB_LINK_TYPE.NEW ? 'N' : type}</em>` : '').join('');
    }

    if(className) {
        props += ` class="${className}"`;
    }

    // onClick 옵션이 있는 경우
    if(id && typeof onClick === 'function') {
        props += ` data-callback="${id}"`;
    }

    return `<a href="${newUrl}" ${props}><span>${title}</span>${icon}</a>`;
};